import {Button, Form, Row, Select} from "antd";
import {medicalSuppliesService} from "api";
import {isValuable, randomId} from "helper/common";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
const BoVTModal = forwardRef((props: any, ref) => {
  const {closeModal, setDataTable, khoXuatId} = props;
  const [listBo, setListBo] = useState<any>();
  const [options, setOptions] = useState<any[]>();
  const [form] = Form.useForm();
  useEffect(() => {
    const getListBoVTYT = async khoXuatId => {
      try {
        const res = await medicalSuppliesService.getListBoVTYT({
          type: "VTYT",
        });
        setListBo(res);
      } catch (error) {}

      // console.log(res);
    };

    getListBoVTYT(khoXuatId);
  }, [khoXuatId]);
  useImperativeHandle(ref, () => ({
    resetFields: () => {
      form.resetFields();
    },
  }));
  useEffect(() => {
    setOptions(listBo?.map(e => ({value: e?.id, label: e?.ten})));
  }, [listBo]);
  const submit = async () => {
    const idBo = form.getFieldValue("bo");
    let listVT = [];
    console.log(khoXuatId);
    if (isValuable(khoXuatId)) {
      try {
        listVT = await medicalSuppliesService.getListBoVTYTTheoKho({
          type: "VTYT",
          boId: idBo,
          storeId: khoXuatId,
        });
      } catch (error) {}
    } else {
      listVT = listBo
        ?.find(e => e?.id == idBo)
        ?.vatTuYTeDtos?.map(vt => ({...vt, vtytid: vt?.id}));
    }

    setDataTable(listVT?.map(e => ({...e, key: randomId()})));
    closeModal();
  };
  return (
    <div>
      <Row justify={"end"}>
        <Form form={form}>
          <Form.Item name={"bo"}>
            <Select
              placeholder="Chọn bộ vật tư"
              options={options}
              showSearch
              allowClear={true}
              filterOption={(input, option) =>
                (option?.label.toString().toLowerCase() ?? "").includes(
                  input.toLowerCase()
                )
              }
            ></Select>
          </Form.Item>
        </Form>

        <Button type="primary" style={{marginTop: 4}} onClick={submit}>
          Xác nhận
        </Button>
      </Row>
    </div>
  );
});
export default BoVTModal;
